module.exports = __webpack_public_path__ + "static/media/Sleper_KLaring_teruglezen.723c08e2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/01/assets/Sleper_KLaring_teruglezen.mp3
// module id = 549
// module chunks = 0